/**
 * StepSucceedConditionType - Condition qui vérifie si une étape a réussi
 * Identique à Java StepSucceedCondition
 */

import {ConditionType} from '../types/ConditionType';
import {GameState} from '../../../models/GameState';
import {PlayerStep} from '../../../models/PlayerStep';
import GameRegistry from '../../GameRegistry';
import {StepType} from '../../types/StepType';

export class StepSucceedConditionType implements ConditionType {
  typeName = 'COND_STEP_SUCCEED';
  messageKey = 'laventurier.condition.succeed.name';
  descriptionKey = 'laventurier.condition.succeed.desc';
  errorKey = 'laventurier.condition.succeed.error';
  hasValue = false;
  hasAttribute = false;

  evaluate(gameState: GameState, condition: any, currentStep?: PlayerStep): boolean {
    // Si currentStep n'est pas fourni, utiliser l'étape courante du gameState
    const step = currentStep || (gameState.data.currentStepNumber ? {
      numero: gameState.data.currentStepNumber,
      type: '',
    } as PlayerStep : null);

    if (!step) {
      console.log('[StepSucceedConditionType] FALSE: no current step');
      return false;
    }

    // Vérifier si l'étape courante a réussi en utilisant le StepType
    try {
      const stepTypeName = step.type || 'STEP_SIMPLE';
      const stepType = GameRegistry.getStepType(stepTypeName) as StepType | undefined;
      
      if (stepType && stepType.checkSuccess) {
        const result = stepType.checkSuccess(gameState, step);
        console.log(`[StepSucceedConditionType] ${result ? 'TRUE' : 'FALSE'}: step ${step.numero} checkSuccess returned ${result}`);
        return result;
      }

      // Fallback: vérifier si le type de l'étape est STEP_SUCCEED ou si le gameState est SUCCEED
      const stepTypeUpper = stepTypeName.toUpperCase();
      const isSucceedType = stepTypeUpper === 'STEP_SUCCEED' || stepTypeUpper === 'SUCCEED';
      const isGameStateSucceed = gameState.state === 'SUCCEED';
      
      const result = isSucceedType || isGameStateSucceed;
      console.log(`[StepSucceedConditionType] ${result ? 'TRUE' : 'FALSE'}: step ${step.numero} type=${stepTypeName}, gameState.state=${gameState.state}`);
      return result;
    } catch (error) {
      console.error('[StepSucceedConditionType] Error evaluating condition:', error);
      return false;
    }
  }
}
